import PrototypeManager from "./WaveFunctionCollapseV2/Prototype/PrototypeManager.ts";
import PrototypeImpl from "./PrototypeImpl.ts";
import PrototypeInput from "./WaveFunctionCollapseV2/Prototype/PrototypeInput.ts";
import Prototype from "./WaveFunctionCollapseV2/Prototype/Prototype.ts";

export default class PrototypeManagerImpl extends PrototypeManager {
  constructor(prototypeInput: PrototypeInput) {
    super(prototypeInput);
  }

  static async loadPrototypeInput(path: string): Promise<PrototypeInput> {
    let prototypeInput: PrototypeInput = { prototypes: [], blankId: "0" };

    await fetch(path)
      .then((response) => response.json())
      .then((data) => {
        try {
          prototypeInput = PrototypeInput.parseJsonToPrototypeInput(data);
        } catch (error) {
          console.error("Error parsing prototype data: ", error, data);
        }
      })
      .catch((error) => {
        console.error("Error loading prototype data:", error);
      });

    return prototypeInput;
  }
}
